// components/SEO/Head.js
import React from 'react';
import { Helmet } from 'react-helmet';

const Head = () => {
    return (
        <Helmet>
            {/* البيانات الأساسية */}
            <title>خطوة المستثمر - خدمات استثمارية متكاملة في المملكة العربية السعودية</title>
            <meta name="description" content="خطوة المستثمر تقدم خدمات استشارية متكاملة، تأسيس شركات، تراخيص تجارية، إقامات مميزة، خدمات محاسبية وتسويقية بجودة عالية وخبرة ممتدة" />
            <meta name="keywords" content="استثمار، تأسيس شركات، تراخيص تجارية، إقامة مستثمر، خدمات محاسبية، تسويق إلكتروني، المملكة العربية السعودية" />
            <meta name="author" content="خطوة المستثمر" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta property="og:title" content="خطوة المستثمر - خدمات استثمارية متكاملة" />
            <meta property="og:description" content="الحلول الاستثمارية المتكاملة التي تقدمها خطوة المستثمر بجودة عالية وخبرة ممتدة" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://investor-step.com/" />
        <meta property="og:image" content="https://investor-step.com/static/media/logo.7a1a812b073903d74c99.jpg" />
            <meta property="og:site_name" content="خطوة المستثمر" />

            {/* بيانات Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="خطوة المستثمر - خدمات استثمارية متكاملة" />
            <meta name="twitter:description" content="الحلول الاستثمارية المتكاملة التي تقدمها خطوة المستثمر" />
            <meta name="twitter:image" content="https://investor-step.com/static/media/logo.7a1a812b073903d74c99.jpg" />

            {/* Favicon */}
        <link rel="icon" href="https://investor-step.com/static/media/logo.7a1a812b073903d74c99.jpg" />
            <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://investor-step.com/static/media/logo.7a1a812b073903d74c99.jpg" />
        <link rel="icon" type="image/png" sizes="16x16" href="https://investor-step.com/static/media/logo.7a1a812b073903d74c99.jpg" />
        <link rel="manifest" href="/site.webmanifest" />

            {/* بيانات المنظمة (Schema.org) */}
            <script type="application/ld+json">
                {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "خطوة المستثمر",
            "url": "https://ptutd.com",
            "logo": "https://investor-step.com/images/logo.png",
            "description": "تأسيس شركة في المملكة العربية السعودية , نحن شركة خطوة  المستثمر لخطوات الاعمال, الخدمات العامة، مدد ، قوى ، شركة برمجة في السعودية",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "شارع ديراب",
              "addressLocality": "...",
              "addressRegion": "المملكة العربية السعودية",
              "postalCode": "...",
              "addressCountry": "SA"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+966509150333",
              "contactType": "customer service"
            }
          }
        `}
            </script>
        </Helmet>
    );
};

export default Head;